import React from 'react';

import * as ReturnAuthorizationsTable from '../ReturnAuthorizationTable/ReturnAuthorizationTable';
import { QueryReturnAuthorizationsFilterInput } from 'generated/graphql';



export interface IProps {
  storeId?: string;
}

export const FC: React.FC<IProps> = props => {
  const filter = React.useMemo(
    (): QueryReturnAuthorizationsFilterInput => ({
      authorizationApprovalStatus: ['approved'],
      isReceived: false,
      storeId: props.storeId
    }),
    [props.storeId]
  );

  return (
    <ReturnAuthorizationsTable.FC
      filter={filter}
      columnIdsToRender={[
        'approvalDate',
        'storeName',
        'orderExternalId',
        'returnNumber',
        'customerFullName',
        'netSuiteSalesOrderRecord',
        'netSuiteReturnAuthorizationRecord',
        'shippingLabel',
        'shippingStatus',
        'itemsFulfilledCount',
        'itemsToBeReturnedCount',
        'receiveItems'
      ]} />
  );
};
